import React, { Component } from "react";
import Modal from 'react-bootstrap/Modal';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import { ErrorText } from '../../../components';

const TYPES = [
    {
        name: 'Home',
        value: 'home',
    },
    {
        name: 'Home Screen Top',
        value: 'home_screen_top'
    },
    {
        name: 'Home Screen Offer Top',
        value: 'home_screen_offer_top'
    },
    {
        name: 'Subcategory',
        value: 'subcategory'
    },
    {
        name: 'Product Banner Top',
        value: 'web_banner_1'
    },
    {
        name: 'Product Bottom Top',
        value: 'web_banner_2'
    },
]

export default class BannerModal extends Component {
    constructor() {
        super()
        this.state = this.initState();
    }

    initState = () => ({
        form: {
            bannerImage: '',
            screen: '',
            title: '',
            categoryId: '',
            subcategoryId: '',
        },
        errors: {}
    })

    componentDidUpdate(prevProps) {
        if (this.props.data.id && prevProps.data.id !== this.props.data.id) {
            this.setEditMode()
        }
    }

    setEditMode = () => {
        const { data } = this.props;
        if (data.categoryId) {
            this.props.onCategoryChange(data.categoryId);
        }
        this.setState({
            form: {
                title: data.title||'',
                screen: data.screen||'',
                categoryId: data.categoryId || '',
                subcategoryId: data.subcategoryId || '',
                bannerImage: data.bannerImage,
            }
        })
    }


    onSave = () => {
        if (!this.validateForm()) return
        const { data } = this.props;
        const { form } = this.state;
        this.props[data.id ? 'editBanner' : 'addBanner'](data.id ? { ...form, id: data.id } : form);
    }

    validateForm = () => {
        const { form } = this.state;
        const { subCategories } = this.props;
        const errors = {};

        // if (!form.title) errors.title = 'Required';
        if (!form.screen) errors.screen = 'Required';
        if (form.screen === 'home'||form.screen === 'home_screen_top'||form.screen === 'home_screen_offer_top') {
            if (!form.categoryId) errors.categoryId = 'Required';
            if (subCategories.length && !form.subcategoryId) errors.subcategoryId = 'Required';
        }
        if (!form.bannerImage) errors.bannerImage = 'Required';
        else if (typeof form.bannerImage !== 'string' && (form.bannerImage.size / 1024 / 1024) > 10) errors.bannerImage = 'File should be less than 10 MB.';

        this.setState({ errors });

        return isEmpty(errors)
    }

    onInputChange = e => {
        const { name, value, files } = e.target
        this.setState(state => ({
            form: {
                ...state.form,
                subcategoryId: name === 'categoryId' ? '' : state.form.subcategoryId,
                [name]: name === 'bannerImage' ? files[0] : value,
            },
            errors: {
                ...state.errors,
                [name]: '',
            }
        }), () => {
            if (name === 'categoryId') this.props.onCategoryChange(value)
        })
    }

    onClose = () => {
        this.setState(this.initState())
        this.props.onHide();
    }

    render() {
        const { form, errors } = this.state;
        const { show, categories, subCategories,data } = this.props;
  
        return (
            <Modal
                show={show}
                onHide={this.onClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                       Banner
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-6 mb-2">
                            <div className="form-group">
                                <label className={classNames({'text-danger': errors.title})}>Title</label>
                                <input
                                    type="text"
                                    name="title"
                                    value={form.title}
                                    onChange={this.onInputChange}
                                    placeholder="Title"
                                    className={classNames('form-control', { 'is-invalid': errors.title })}
                                    maxLength="20"
                                />
                                <ErrorText error={errors.title}/>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames({'text-danger': errors.screen})}>Screen</label>
                                <select
                                    disabled={form.screen&&data.id}
                                    name="screen"
                                    value={form.screen}
                                    onChange={this.onInputChange}
                                    className={classNames('form-control', { 'is-invalid': errors.screen })}
                                >
                                    <option value="" disabled>Select</option>
                                    {TYPES.map(type => (
                                        <option key={type.value} value={type.value}>{type.name}</option>
                                    ))}
                                </select>
                                <ErrorText error={errors.screen}/>
                            </div>
                        </div>
                        {(form.screen === 'home'||form.screen === 'home_screen_top'||form.screen === 'home_screen_offer_top') && (
                            <>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className={classNames({'text-danger': errors.categoryId})}>Category</label>
                                        <select
                                            name="categoryId"
                                            value={form.categoryId}
                                            onChange={this.onInputChange}
                                            className={classNames('form-control', { 'is-invalid': errors.categoryId })}
                                        >
                                            <option value="" disabled>Select</option>
                                            {categories.map(category => <option key={category.id} value={category.id}>{category.displayName}</option>)}
                                        </select>
                                        <ErrorText error={errors.categoryId}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className={classNames({'text-danger': errors.subcategoryId})}>Subcategory</label>
                                        <select
                                            name="subcategoryId"
                                            value={form.subcategoryId}
                                            onChange={this.onInputChange}
                                            disabled={!subCategories.length}
                                            className={classNames('form-control', { 'is-invalid': errors.subcategoryId })}
                                        >
                                            <option value="" disabled>Select</option>
                                            {subCategories.map(category => <option key={category.id} value={category.id}>{category.displayName}</option>)}
                                        </select>
                                        <ErrorText error={errors.subcategoryId}/>
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className={classNames('mr-2', {'text-danger': errors.bannerImage})}>Image</label>
                                <input
                                    ref={ref => { this.fileSelector = ref }}
                                    name="bannerImage"
                                    type="file"
                                    className="hidden" 
                                    onChange={this.onInputChange}
                                />
                                <button className="btn btn-secondary" onClick={() => this.fileSelector.click()}>
                                    {form.bannerImage ? 'Change File' : 'Select Image'}
                                </button>
                                <ErrorText error={errors.bannerImage}/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-danger" onClick={this.onClose}>Close</button>
                    <button className="btn btn-primary" onClick={this.onSave}>Save</button>
                </Modal.Footer>
            </Modal>
        )
    }
};